function checkBatteryAvailability(sku) {
  console.log('new sku is: ' + sku);

  const skuUrl = "https://api.isell.pt/shopify/check_battery_health/" + sku;

  fetch(skuUrl, { cache: "no-store" })
    .then(response => response.json())
    .then(data => {
      //console.log('battery data:', data);

      const batteryUpsell = document.querySelector('.battery-upsell');
      const batteryCheckbox = document.querySelector('.battery-upsell [type="checkbox"]');
if(batteryUpsell) {
      if (data === 1) {
        // Slide down effect
        slideDown(batteryUpsell, 300);
      } else {
        // Slide up effect
        slideUp(batteryUpsell, 300);
        if (batteryCheckbox) {
          batteryCheckbox.checked = false;
        }
      }
      updateTotalPrice();
}
    })
    .catch(error => console.error('Error fetching battery data:', error));
}

function updateTotalPrice() {
        //console.log('updateTotalPrice here');
  const totalElement = document.getElementById('totalPrice');
  let totalSum = 0;

  // Loop through each checked .upsell-checkbox and add its data-price value to the total sum
  document.querySelectorAll('.upsell-checkbox:checked').forEach((checkbox) => {
    const price = parseFloat(checkbox.getAttribute('data-price')) || 0;
    totalSum += price;
  });

  // Get the value of the hidden input containing the variant ID
  const variantIdElement = document.querySelector('product-info input[type="hidden"].product-variant-id');
  if (variantIdElement) {
    const selectedVariantId = parseInt(variantIdElement.value, 10); // Assuming the value is the variant ID

    // Find the matching variant data by ID
   
    //console.log('variantId:', selectedVariantId)

    // Parse the JSON data from the script element
    const variantDataScript = document.getElementById('variant-inventory-data');
    if (variantDataScript) {
      const variantData = JSON.parse(variantDataScript.textContent);
//console.log(variantData);
      // Find the variant in the JSON data that matches the variant ID
      const matchingVariant = variantData.variants.find(variant => variant.id === selectedVariantId);
 if (matchingVariant) {
     const totalHolder = document.querySelector('.total-holder');
     const upsellsHolder = document.querySelector('.product-upsells');
     
     // FIXED AVAILABILITY CHECK: Use Shopify's built-in availability as primary check
     // This aligns with Shopify best practices and ensures consistency
     const isVariantAvailable = matchingVariant.available;
     
      if(isVariantAvailable){
        
         slideDown(totalHolder, 300);
         slideDown(upsellsHolder, 300);
     
        // Add a specific property from the matching variant to the total sum (e.g., price)
        const variantPrice = parseFloat(matchingVariant.price) || 0; // Adjust as needed if price is stored differently
        totalSum += variantPrice;
     //console.log('matchingVariant found. Price: ', variantPrice);
         }
        else{
          
         slideUp(totalHolder, 300);
         slideUp(upsellsHolder, 300);
        }

      }
      else{
        //console.log('no matchingVariant found');
      }
    }
  }
        else{
          
    //console.log('no variantId')
        }

        //console.log(totalSum);

  // Update the total price element with the summed value
  totalElement.textContent = formatPrice(totalSum); // Format to two decimal places
}

function updateVariantSelection() {
    // Get selected values in order
    const selectedValues = Array.from(
      document.querySelectorAll('.product-form__input--pill input:checked')
    ).map(input => input.value);

    // Retrieve variants data from embedded JSON script
    const variantsData = JSON.parse(document.getElementById('variant-inventory-data').textContent);

    //console.log(selectedValues);
    // Filter variants by selected values
    const matchingVariants = variantsData.variants.filter(variant => {
      //console.log(variant);
      const variantOptions = [variant.option1, variant.option2, variant.option3];
      //console.log(variantOptions);
      return selectedValues.every(value => variantOptions.includes(value));
    });

    //console.log(matchingVariants); // Output matching variants

 const colorInputs = document.querySelectorAll('.color-holder input');

colorInputs.forEach(input => {
  const colorValue = input.value; // Get the color value (e.g., "Natural Titanium")
  
  // Find the matching variant based on the color value
  const matchingVariant = matchingVariants.find(variant => 
    variant.option1 === colorValue || 
    variant.option2 === colorValue || 
    variant.option3 === colorValue
  );

  // Get the label holder for this color input
  const colorLabelHolder = input.closest('.color-holder').querySelector('.color-label-holder');
  //console.log(colorLabelHolder);
  // Ensure colorLabelHolder is found
  if (colorLabelHolder) {
    // If the variant has a backorder, add the 'backorder' class, otherwise remove it
    if (matchingVariant && matchingVariant.backorder === 1) {
      //console.log('variant is backorder');
      colorLabelHolder.classList.add('backorder');
      colorLabelHolder.classList.remove('normal');
    } else {
      //console.log('variant is not backorder');
      colorLabelHolder.classList.remove('backorder');
      colorLabelHolder.classList.add('normal');
    }
  } else {
    //console.log('No color label holder found for', colorValue);
  }
});
  }

function syncAllVariantSelectors() {
  const selectedVariantScript = document.querySelector('[data-selected-variant]');
  if (!selectedVariantScript) return;
  
  try {
    const selectedVariant = JSON.parse(selectedVariantScript.textContent);
    if (!selectedVariant) return;
    
    const variantOptions = [selectedVariant.option1, selectedVariant.option2, selectedVariant.option3].filter(Boolean);
    if (variantOptions.length === 0) return;

    // This covers all option groups: pills for quality/capacity, and colors.
    const allOptionInputs = document.querySelectorAll('.product-form__input input[type="radio"]');
    
    allOptionInputs.forEach(input => {
      if (variantOptions.includes(input.value)) {
        input.checked = true;
      }
    });

  } catch (error) {
    console.error('Error syncing variant selectors:', error);
  }
  }

document.addEventListener("DOMContentLoaded", function() {
  // Sync all variant selectors with the selected variant when page loads
  syncAllVariantSelectors();
  
  // Get all variant inputs
  const variantInputs = document.querySelectorAll('.product-form__input--pill input');
  
  // Event listener for option changes
  variantInputs.forEach(input => {
   // console.log('input changed');
    input.addEventListener('change', updateVariantSelection);
  });

   const upsellOptions = document.querySelectorAll('.upsell-checkbox');
  
upsellOptions.forEach(input => {
    input.addEventListener('change', updateTotalPrice);
  });

  
// Parse the variant inventory data from the embedded JSON script tag
const variantData = JSON.parse(document.getElementById("variant-inventory-data").textContent);

// Add an event listener to .product-variant-id elements
document.querySelectorAll('product-info input.product-variant-id').forEach(variantInput => {
  
      const selectedVariantId = parseInt(variantInput.value, 10); // Assuming the value is the variant ID
console.log('selectedVariantId: ', selectedVariantId);
    // Find the matching variant data by ID
  
    var selectedVariant = variantData.variants.find(variant => variant.id === selectedVariantId);

    if (selectedVariant) {
      console.log('selectedVariant found. checkBatteryAvailability');
      // Call the checkBatteryAvailability function with the SKU of the selected variant
      checkBatteryAvailability(selectedVariant.sku);
    } else {
      console.warn('Variant not found for ID:', selectedVariantId);
    }
  
  variantInput.addEventListener('change', function() {
    const selectedVariantId = parseInt(this.value, 10); // Assuming the value is the variant ID

    // Find the matching variant data by ID
    const selectedVariant = variantData.variants.find(variant => variant.id === selectedVariantId);

    if (selectedVariant) {
      // Call the checkBatteryAvailability function with the SKU of the selected variant
      checkBatteryAvailability(selectedVariant.sku);
    } else {
      console.warn('Variant not found for ID:', selectedVariantId);
    }
  });
});

});

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      adjustAvailableOptions(){
const checkedDisabledInput = document.querySelector('.product-form__input input.disabled:checked');

if (checkedDisabledInput) {
  // Get the parent .product-form__input
  const parent = checkedDisabledInput.closest('.product-form__input');
  
  // Find the first input that is not disabled within the parent
  const firstEnabledInput = parent.querySelector('input:not(.disabled)');
  
  if (firstEnabledInput) {
    firstEnabledInput.checked = true; // Check the first enabled input
    console.log('Checked the first enabled input.');
  } else {
    console.log('No enabled input found in the parent.');
  }
} else {
  console.log('No checked disabled input found.');
}

      }



// Updated method in the ProductInfo class
toggleKlarnaVisibility(variant) {
  const klarnaElement = document.querySelector('klarna-placement, #klarna-osm-container'); // Global scope for Klarna
  const lowStockAlert = this.querySelector('.low-stock-alert'); // Scoped to product-info

  console.log('toggleKlarnaVisibility - variant:', variant);
  console.log('klarnaElement found:', !!klarnaElement, 'lowStockAlert found:', !!lowStockAlert);

  if (klarnaElement) {
    const shouldShowKlarna = variant && variant.available;
    klarnaElement.style.display = shouldShowKlarna ? 'block' : 'none';
    console.log('Klarna display set to:', klarnaElement.style.display);
  } else {
    console.log('Klarna element not found');
  }

  if (lowStockAlert) {
    const shouldShowLowStock = variant && variant.available;
    lowStockAlert.style.display = shouldShowLowStock ? 'block' : 'none';
    console.log('Low stock alert display set to:', lowStockAlert.style.display);
  } else {
    console.log('Low stock alert element not found');
  }
}

// Updated handleUpdateProductInfo method in the ProductInfo class
handleUpdateProductInfo(productUrl) {
  console.log('handleUpdateProductInfo');
  return (html) => {
    const variant = this.getSelectedVariant(html);

    this.pickupAvailability?.update(variant);
    this.updateOptionValues(html);
    this.updateURL(productUrl, variant?.id);
    this.updateVariantInputs(variant?.id);

    if (!variant) {
      console.log('variant not found');
      this.setUnavailable();
      this.toggleKlarnaVisibility(null); // Hide both when no variant
      return;
    }

    console.log('current variant: ', variant);

    this.updateMedia(html, variant?.featured_media?.id);

    const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
      const source = html.getElementById(`${id}-${this.sectionId}`);
      const destination = this.querySelector(`#${id}-${this.dataset.section}`);
      if (source && destination) {
        destination.innerHTML = source.innerHTML;
        destination.classList.toggle('hidden', shouldHide(source));
      }
    };

    updateSourceFromDestination('price');
    updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
    updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
    updateSourceFromDestination('Volume');
    updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

    this.updateQuantityRules(this.sectionId, html);
    this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
    this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

    // Reset the button text to "Add to Cart" when variant changes
    const submitButton = this.querySelector(`#ProductSubmitButton-${this.sectionId}`);
    if (submitButton) {
      const addToCartSpan = submitButton.querySelector('.add-to-cart');
      const addedToCartSpan = submitButton.querySelector('.added-to-cart');
      if (addToCartSpan && addedToCartSpan) {
        addToCartSpan.style.display = 'inline';
        addedToCartSpan.style.display = 'none';
      }
    }

    this.productForm?.toggleSubmitButton(
      html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
      window.variantStrings.soldOut
    );

    // Toggle Klarna and low stock alert based on variant availability
    this.toggleKlarnaVisibility(variant);

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.sectionId,
        html,
        variant,
      },
    });
  };
}



      
      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id[]"]');
          //console.log(input);
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

updateQuantityRules(sectionId, html) {
  if (!this.quantityInput) return;
  this.setQuantityBoundries();

  const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
  if (!this.quantityForm || !quantityFormUpdated) {
    console.warn('Missing quantity form elements:', {
      quantityForm: this.quantityForm,
      quantityFormUpdated: quantityFormUpdated,
    });
    return; // Exit if either form element is missing
  }

  const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
  for (let selector of selectors) {
    const current = this.quantityForm.querySelector(selector);
    const updated = quantityFormUpdated.querySelector(selector);
    if (!current || !updated) continue; // Skip if either element is missing
    if (selector === '.quantity__input') {
      const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
      for (let attribute of attributes) {
        const valueUpdated = updated.getAttribute(attribute);
        if (valueUpdated !== null) {
          current.setAttribute(attribute, valueUpdated);
        } else {
          current.removeAttribute(attribute);
        }
      }
    } else {
      current.innerHTML = updated.innerHTML;
    }
  }
}

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}



